<template>
  <v-dialog :value="isShow" max-width="1000" persistent>
    <v-card class="text-center">
      <!-- <template v-if="errorMessage">
        <v-alert type="error">{{ errorMessage }}</v-alert>
      </template> -->
      <validation-observer v-slot="{ handleSubmit }">
        <v-card-title class="text-sm-left font-weight-bold">
          Chuyển Sale gia hạn
          <v-spacer />
          <v-icon aria-label="Close" @click="hideModal">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="px-6">
          <v-row>
            <v-col cols="12" md="12">
              <!-- <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                rules="required"
                name="Chuyển sale gia hạn"
              > -->
                <common-select-user
                  v-model="sale"
                  :items="listSale"
                  color="primary"
                  item-text="fullName"
                  :item-value="(item) => item"
                />
              <!-- </validation-provider> -->
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-4 w-full d-flex justify-end">
          <div class="d-flex justify-space-between" style="width:27%">
            <v-btn class="cancel-button" @click="hideModal">Hủy bỏ</v-btn>
            <v-spacer />
            <v-btn class="update-button" @click="handleSubmit(saveChange)">Xác nhận</v-btn>
          </div>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import * as moment from 'moment';
import { TYPE_CURRICULUM_OBJ } from '@/helpers/constant';
import TokenService from '../../../helpers/token';
import ContactServices from '../../../services/ContactRepository';

export default {
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    filterForm: {
      type: Object,
      default: () => {},
    },
    studentForm: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      TYPE_CURRICULUM_OBJ,
      showModal: false,
      errorMessage: '',
      sale: {},
      isValidNoSale: true,
    };
  },
  watch: {
    sale(value) {
      if (!value) {
        this.sale = {};
      }
    },
  },
  created() {
    const dataUser = TokenService.getUser() || {};
    this.userId = _.get(dataUser, 'id', '');
  },
  computed: {
    ...mapState('student_care', ['listSale', 'dataPeriodicallyCareTable']),
    ...mapState('contact_status', ['allListStatus']),
  },
  methods: {
    ...mapActions('student_care', ['changeSaleExtend', 'getDataPeriodicallyCareTable', 'getListCallStatusCount']),
    hideModal() {
      this.$emit('close-modal-add-head-teacher', false);
      this.errorMessage = '';
      this.userId = '';
    },
    async saveChange() {
      if (this.dataPeriodicallyCareTable && this.dataPeriodicallyCareTable.data && this.dataPeriodicallyCareTable.data.length > 0) {
        const listSelectedId = [];
        const oldData = [];
        this.dataPeriodicallyCareTable.data.forEach(
          (contact) => {
            if (contact.checkbox) {
              listSelectedId.push(contact.id);
              if (contact.type_customer_care !== 2 && contact.type_customer_care !== 1 && contact.type_customer_care !== 4 && this.$route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE) {
                this.isValidNoSale = false;
              }
              oldData.push({ id: contact.id, call_id: contact.call_id, extend_sale_name: contact.extend_sale_name });
            }
          },
        );
        if (listSelectedId.length === 0) {
          return this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Vui lòng chọn khách hàng !!!',
          });
        }

        if (!this.sale.id || !this.sale.fullName) {
          if (this.$route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE) {
            if (!this.isValidNoSale) {
              return this.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: 'Vui lòng chọn Sale gia hạn !!!',
              });
            }
            return this.$swal({
              title: '<p style="font-size: 16px; font-weight: normal">Chuyển sale và không phân sale gia hạn</p>',
              html: '<p style="font-weight: bold; font-size: 20px">Bạn có muốn tiếp tục ?</p>',
              showCancelButton: true,
              cancelButtonText: 'Hủy',
              confirmButtonText: 'Xác nhận',
              confirmButtonColor: '#FD1F6D',
            }).then(async (result) => {
              if (result.isConfirmed) {
                const res = await ContactServices.updateSale({
                  ids: listSelectedId,
                  userId: this.sale.id,
                });
                if (res) {
                  this.hideModal();
                  await this.getDataPeriodicallyCareTable(this.filterForm);
                  await this.getListCallStatusCount(this.filterForm);
                  this.filterForm.checkboxAll = false;
                  this.$swal({
                    type: 'success',
                    title: 'Thành công',
                    text: 'Chuyển sale gia hạn thành công!!!',
                  });
                  this.isValidNoSale = true;
                }
              }
            });
          }
          return this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: 'Vui lòng chọn Sale gia hạn !!!',
          });
        }

        let csCallId = 0;
        let csMoiCallStatusId = 0;
        if (this.allListStatus && this.allListStatus.length > 0) {
          for (let i = 0; i < this.allListStatus.length; i += 1) {
            if (this.allListStatus[i] && this.allListStatus[i].name === this.checkTypeCs() && this.allListStatus[i].data && this.allListStatus[i].data.length > 0) {
              for (let j = 0; j < this.allListStatus[i].data.length; j += 1) {
                if (this.allListStatus[i].data[j] && this.allListStatus[i].data[j].code === 'MOI') {
                  csCallId = this.allListStatus[i].id;
                  csMoiCallStatusId = this.allListStatus[i].data[j].id;
                  break;
                }
              }
            }
            if (csCallId && csMoiCallStatusId) {
              break;
            }
          }
        }
        let result = null;
        const loading = this.$loading.show();
        if (this.$route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE) {
          result = await ContactServices.updateSale({
            ids: listSelectedId,
            userId: this.sale.id,
          });
        }
        if (this.$route.query.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY) {
          result = await this.changeSaleExtend({
            obj: 'routine',
            data: {
              call_id: csCallId,
              call_status_id: csMoiCallStatusId,
              type_customer_care: 3,
              extend_sale_id: this.sale.id,
              extend_sale_name: this.sale.fullName,
              extend_sale_at: this.formatDateCustom(Date.now()),
            },
            filters: {
              $in__id: listSelectedId,
            },
            oldData,
          });
        }
        loading.hide();
        if (result) {
          this.hideModal();
          await this.getDataPeriodicallyCareTable(this.filterForm);
          await this.getListCallStatusCount(this.filterForm);
          this.filterForm.checkboxAll = false;
          return this.$swal({
            type: 'success',
            title: 'Thành công',
            text:
              'Chuyển sale gia hạn thành công!!!',
          });
        }
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text:
                  'Có lỗi khi chuyển sale gia hạn !!!',
        });
      }

      return true;
    },
    checkTypeCs() {
      if (this.$store.state.typeCurriculum === TYPE_CURRICULUM_OBJ.ONLINE) {
        return 'TA - CS';
      }
      if (this.$store.state.typeCurriculum === TYPE_CURRICULUM_OBJ.IELTSY) {
        return 'CS';
      }
      return '';
    },
    formatDateCustom(date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
  },
};
</script>
<style scoped>
.w-full {
  width: 100%;
}
.update-button {
  background-color: #fd1f6d !important;
  color: white;
}
.cancel-button {
  background: #BDBDBD !important;
  color: white;
}
</style>
